import { ReplaySubject } from 'rxjs';
import { ListStatusCount } from './../model/list-status-count.model';
import {Injectable} from '@angular/core';
import { CplRequestItem } from '../model/cpl-request-item.model';
import { RequestItemApi } from '../api/request-item.api';
import { CplRequestBasicData } from '../model/cpl-request-basic-data.model';
import { finalize, tap } from 'rxjs/operators';
import { CplRequestDuplicateData } from '../model/cpl-request-duplicate-data.model';
import { PagedResponse, SessionService } from '@edl-development/edl-common';

@Injectable()
export class RequestItemService {

    private _listStatusCount: ListStatusCount = null;
    listStatusCount:ReplaySubject<any> = new ReplaySubject(1);

    constructor(
        private requestItemApi: RequestItemApi, 
        private sessionService:SessionService

    ) {
        this._listStatusCount = new ListStatusCount();
    }

    BroadcastListStatusCount(pagedResponse:PagedResponse){
        let statusCount = new ListStatusCount();
        statusCount.TotalPending = pagedResponse.TotalPending;
        statusCount.TotalExpiring = pagedResponse.TotalExpiring;
        statusCount.TotalExpired = pagedResponse.TotalExpired;
        this._listStatusCount = statusCount;
        this.listStatusCount.next(this._listStatusCount);
    }

    convertToTemplate = (requestData: CplRequestDuplicateData) => this.requestItemApi.convertToTemplate(requestData);

    createItem = (requestItem: CplRequestItem) => this.requestItemApi.createItem(requestItem);

    deleteItem = (requestID: CplRequestBasicData) => this.requestItemApi.deleteItem(requestID);

    duplicateItem = (requestData: CplRequestDuplicateData) => this.requestItemApi.duplicateItem(requestData);

    activateItem = (requestID: CplRequestBasicData) => this.requestItemApi.activateItem(requestID);

    archiveItem = (requestID: CplRequestBasicData) => this.requestItemApi.archiveItem(requestID);

    restoreItem = (requestID: CplRequestBasicData) => this.requestItemApi.restoreItem(requestID);

    getArchiveWarnings = (requestId: string) => this.requestItemApi.getArchiveWarnings(requestId);

    getRequestItems(offset: number, limit: number, orderBy: string, ascending: boolean, type:number, searchBy?: string, status?: number, tag?:number,updateStatusCounts:boolean=true) {
        this.sessionService.AppLoading(true);
        return this.requestItemApi
            .getRequestItems(offset, limit, orderBy, ascending, type, searchBy, status, tag)
            .pipe(
                tap((data) => this.updateStatusCounts(updateStatusCounts, data)),
                finalize(() => this.sessionService.AppLoading(false))
            );
    }

    getOpenRequestItems(offset: number, limit: number, orderBy: string, ascending: boolean, searchBy?: string, status?: number, tag?:number, updateStatusCounts:boolean=true) {
        this.sessionService.AppLoading(true);
        return this.requestItemApi
            .getOpenRequestItems(offset, limit, orderBy, ascending, searchBy, status, tag)
            .pipe(
                tap((data) => this.updateStatusCounts(updateStatusCounts, data)),
                finalize(() => this.sessionService.AppLoading(false))
            );
    }
    
    getRequestItem(requestID: string, includeUserStatusCounts: boolean = false) {
        this.sessionService.AppLoading(true);
        return this.requestItemApi
            .getRequestItem(requestID, includeUserStatusCounts)
            .pipe(
                finalize(() => this.sessionService.AppLoading(false))
            );
    }

    updateRequestItem = (requestItem: CplRequestItem) => this.requestItemApi.updateRequestItem(requestItem);

    private updateStatusCounts(updateStatusCounts:boolean, data:any) {
        if(updateStatusCounts) {
            this.BroadcastListStatusCount(data);
        }
    }
}